import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import ListEquipments from '../ListEquipments'
import { validateEmailFunc, isRutValid, validateCell, beforeMaskedValueChangeRut, decode_utf8, maxFileSize, getSignedIdStatus, extensionsAccepted, transformId } from '../../../../common/utils/utilsFunc';
import WebContentTermsElectrod from '../WebContentTermsElectrod';
import { useModal } from "@clayui/modal";
import FileUploaded from "../../../../common/components/FileUploader";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function FormsElectrodependent({ props }) {
    const [listEquipUsed, setListEquipUsed] = React.useState([])
    const [valueCheckBoxEmail, setValueCheckBoxEmail] = React.useState(false);
    const [valueCheckBoxCell, setValueCheckBoxEmCell] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [valueCheckBoxTerms, setValueCheckBoxTerms] = React.useState(false);
    const [erroUploadFile, setErroUploadFile] = React.useState();
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });

    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": props.state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    React.useEffect(() => {
        if (props.resetForm) {
            setValues({
                regionPatient: 0,
                comunaPatient: 0,
                calle: "",
                calleNDptoPatient: "",
                cellphoneDoctor: "",
                cellphonePatient: "",
                cellphoneTutor: "",
                cityInstitution: "",
                comuna: "",
                diagnosticPatient: "",
                descuento: "",
                dpto: "",
                edadPatient: "",
                emailNotification: "",
                emailPatient: "",
                emailTutor: "",
                fechaDesde: "",
                fechaHora: "",
                fileCertificate: null,
                fileContactData: null,
                fileCredentialRepres: null,
                filePatientIdentity: null,
                filePatientRepresIdentity: null,
                ticketCopy: null,
                nameDirector: "",
                nameDoctor: "",
                nameInstitution: "",
                namePatient: "",
                nameTutor: "",
                number: "",
                ratedPower: "",
                roleDoctor: "",
                rutDoctor: "",
                rutPatient: "",
                rutTutor: "",
                socialReason: "",
                timeDailyConected: "",
                typeEquipament: "",
                typeEquipamentName: ""
            })
            clearInputFile("fileCertificate")
            clearInputFile("fileContactData")
            clearInputFile("fileCredentialRepres")
            clearInputFile("filePatientIdentity")
            clearInputFile("filePatientRepresIdentity")
            clearInputFile("ticketCopy")
            setListEquipUsed([])
            setValueCheckBoxTerms(false)
            setValueCheckBoxEmail(false)
            setValueCheckBoxEmCell(false)
            props.setDetailClientJson([])
            props.setResetForm(false)
        }
    }, [props.resetForm])

    React.useEffect(() => {
        if (erroUploadFile) {
            props.setGlobalAlert(erroUploadFile, "warning");
        }
    }, [erroUploadFile]);

    function clearInputFile(id) {
        let inputFile = document.querySelector(`#${id}`);
        inputFile.value = ''
    }
    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };
        if (values.regionPatient) {
            errors.empty.regionPatient = false;
        } else {
            errors.empty.regionPatient = true;
            errors.msg.regionPatient = "Debes seleccionar Región donde reside el paciente"
        }


        if (values.comunaPatient) {
            errors.empty.comunaPatient = false;
        } else {
            errors.empty.comunaPatient = true;
            errors.msg.comunaPatient = "Debes seleccionar Comuna donde reside el paciente"
        }


        if (values.fechaDesde) {
            errors.empty.fechaDesde = false;
        } else {
            errors.empty.fechaDesde = true;
            errors.msg.fechaDesde = "Debes ingresar fecha desde"
        }

        if (values.fechaHora) {
            errors.empty.fechaHora = false;
        } else {
            errors.empty.fechaHora = true;
            errors.msg.fechaHora = "Debes ingresar fecha hasta"
        }


        if (valueCheckBoxTerms) {
            errors.empty.valueCheckBoxTerms = false;
        } else {
            errors.empty.valueCheckBoxTerms = true;
            errors.msg.valueCheckBoxTerms = "Debes aceptar los términos y condiciones."
        }

        if (valueCheckBoxCell) {
            if (values.cellphoneNotification) {
                errors.empty.cellphoneNotification = false;
                if (validateCell(values.cellphoneNotification)) {
                    errors.validated.cellphoneNotification = true;
                    errors.msg.cellphoneNotification = "Debes ingresar un teléfono de información para interrupciones programadas válido"
                } else {
                    errors.validated.cellphoneNotification = false;
                }
            }
            else {
                errors.empty.cellphoneNotification = true;
                errors.msg.cellphoneNotification = "Debes ingresar un teléfono de información para interrupciones programadas"
            }
        } else {
            errors.empty.cellphoneNotification = false;
            errors.validated.cellphoneNotification = false;
        }

        if (valueCheckBoxEmail) {
            if (values.emailNotification) {
                errors.empty.emailNotification = false;
                if (values.emailNotification && !validateEmailFunc(values.emailNotification)) {
                    errors.validated.emailNotification = true;
                    errors.msg.emailNotification = "Debes ingresar un correo electrónico de información para interrupciones programadas válido"
                } else {
                    errors.validated.emailNotification = false;
                }
            }
            else {
                errors.empty.emailNotification = true;
                errors.msg.emailNotification = "Debes ingresar un correo electrónico de información para interrupciones programadas"
            }
        } else {
            errors.empty.emailNotification = false;
            errors.validated.emailNotification = false;
        }


        if (values.namePatient) {
            errors.empty.namePatient = false;
        } else {
            errors.empty.namePatient = true;
            errors.msg.namePatient = "Debes ingresar el nombre del paciente "
        }

        if (values.nameTutor) {
            errors.empty.nameTutor = false;
        } else {
            errors.empty.nameTutor = true;
            errors.msg.nameTutor = "Debes ingresar el nombre del representante legal o apoderado del paciente"
        }

        if (values.fileCertificate) {
            errors.empty.fileCertificate = false;
        } else {
            errors.empty.fileCertificate = true;
            errors.msg.fileCertificate = "Debes adjuntar certificado médico que acredita condición de electrodependencia"
        }

        if (values.fileContactData) {
            errors.empty.fileContactData = false;
        } else {
            errors.empty.fileContactData = true;
            errors.msg.fileContactData = "Debes adjuntar el formulario con los datos de contacto con el paciente y su representante o apoderado"
        }

        if (values.filePatientIdentity) {
            errors.empty.filePatientIdentity = false;
        } else {
            errors.empty.filePatientIdentity = true;
            errors.msg.filePatientIdentity = "Debes adjuntar Cédula de Identidad del paciente electrodependiente"
        }

        if (values.filePatientRepresIdentity) {
            errors.empty.filePatientRepresIdentity = false;
        } else {
            errors.empty.filePatientRepresIdentity = true;
            errors.msg.filePatientRepresIdentity = "Debes adjuntar Cédula de Identidad del representante o apoderado del paciente electrodependiente"
        }

        if (values.ticketCopy) {
            errors.empty.ticketCopy = false;
        } else {
            errors.empty.ticketCopy = true;
            errors.msg.ticketCopy = "Debes adjuntar copia de la boleta donde se inscribe al paciente electrodependiente"
        }

        if (values.fileCredentialRepres) {
            errors.empty.fileCredentialRepres = false;
        } else {
            errors.empty.fileCredentialRepres = true;
            errors.msg.fileCredentialRepres = "Debes adjuntar documento que acredita al representante o apoderado del paciente"
        }

        if (values.emailPatient) {
            errors.empty.emailPatient = false;
            if (values.emailPatient && !validateEmailFunc(values.emailPatient)) {
                errors.validated.emailPatient = true;
                errors.msg.emailPatient = "Debes ingresar un correo electrónico del paciente válido"
            } else {
                errors.validated.emailPatient = false;
            }
        } else {
            errors.empty.emailPatient = true;
            errors.msg.emailPatient = "Debes ingresar el correo electrónico del paciente"
        }

        if (values.emailTutor) {
            errors.empty.emailTutor = false;
            if (values.emailTutor && !validateEmailFunc(values.emailTutor)) {
                errors.validated.emailTutor = true;
                errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del paciente válido"
            } else {
                errors.validated.emailTutor = false;
            }
        } else {
            errors.empty.emailTutor = true;
            errors.msg.emailTutor = "Debes ingresar el correo electrónico del representante legal o apoderado del pacientee"
        }

        if (values.rutPatient) {
            errors.empty.rutPatient = false;
            if (!isRutValid(values.rutPatient)) {
                errors.validated.rutPatient = true;
                errors.msg.rutPatient = "Debes ingresar un RUT del paciente válido."
            } else {
                errors.validated.rutPatient = false;
            }
        } else {
            errors.empty.rutPatient = true;
            errors.msg.rutPatient = "Debes ingresar el RUT del paciente."
        }

        if (values.rutDoctor) {
            errors.empty.rutDoctor = false;
            if (!isRutValid(values.rutDoctor)) {
                errors.validated.rutDoctor = true;
                errors.msg.rutDoctor = "Debes ingresar un RUT de médico válido."
            } else {
                errors.validated.rutDoctor = false;
            }
        } else {
            errors.empty.rutDoctor = true;
            errors.msg.rutDoctor = "Debes ingresar el RUT de médico."
        }

        if (values.rutTutor) {
            errors.empty.rutTutor = false;
            if (!isRutValid(values.rutTutor)) {
                errors.validated.rutTutor = true;
                errors.msg.rutTutor = "Debes ingresar un RUT del representante legal o apoderado del paciente válido."
            } else {
                errors.validated.rutTutor = false;
            }
        } else {
            errors.empty.rutTutor = true;
            errors.msg.rutTutor = "Debes ingresar el RUT del representante legal o apoderado del paciente."
        }

        if (values.cellphonePatient) {
            errors.empty.cellphonePatient = false;
            if (validateCell(values.cellphonePatient)) {
                errors.validated.cellphonePatient = true;
                errors.msg.cellphonePatient = "Debes ingresar un teléfono válido"
            } else {
                errors.validated.cellphonePatient = false;
            }
        } else {
            errors.empty.cellphonePatient = true;
            errors.msg.cellphonePatient = "Debes ingresar el teléfono del paciente"
        }

        if (values.cellphoneTutor) {
            errors.empty.cellphoneTutor = false;
            if (validateCell(values.cellphoneTutor)) {
                errors.validated.cellphoneTutor = true;
                errors.msg.cellphoneTutor = "Debes ingresar un correo electrónico del representante legal o apoderado del paciente que sea válido"
            } else {
                errors.validated.cellphoneTutor = false;
            }
        } else {
            errors.empty.cellphoneTutor = true;
            errors.msg.cellphoneTutor = "Debes ingresar el teléfono del representante legal o apoderado del paciente"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit() {

        console.log("Valores iniciales de values:", values); 
        console.log("Props recibidas:", props);

        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        } else if (!valueCheckBoxCell && !valueCheckBoxEmail) {
            props.setGlobalAlert("Debes ingresar un medio de información para interrupciones programadas.", "warning");
        } else if (listEquipUsed.length === 0) {
            props.setGlobalAlert("Debes ingresar al menos un equipo de electrodependencia a los que se conecte el paciente.", "warning");
        } else if (verifDateMin()) {
            props.setGlobalAlert("No es posible ingresar una fecha menor a la fecha desde.", "warning");
            setValues({ ...values, fechaHora: "" })
        } else {
            let newList = JSON.parse(JSON.stringify(listEquipUsed))
            newList?.map(obj => {
                let object = Object.keys(obj)?.forEach(key => delete obj["eliminar"]);
                return object
            })
            let json = [
                {
                    "nroCliente": props.detailClientJson.CTA_CTO,
                    "nombrePaciente": values.namePatient,
                    "edadPaciente": values.edadPatient ? values.edadPatient : "",
                    "diagnosticoPaciente": values.diagnosticPatient,
                    "descuentoPaciente": values.descuento,
                    "rutPaciente": values.rutPatient,
                    "fonoPaciente": values.cellphonePatient,
                    "emailPaciente": values.emailPatient,
                    "regionPatient": values.regionPatient,
                    "comunaPatient": values.comunaPatient,
                    "calleNDptoPatient": values.calleNDptoPatient,
                    "nombreTutor": values.nameTutor,
                    "rutTutor": values.rutTutor,
                    "fonoTutor": values.cellphoneTutor,
                    "emailTutor": values.emailTutor,
                    "fechaDesde": `${values.fechaDesde}`,
                    "fechaHasta": `${values.fechaHora}`,
                    "nombreMedico": values.nameDoctor ? values.nameDoctor : "",
                    "rutMedico": values.rutDoctor ? values.rutDoctor : "",
                    "cargoMedico": values.roleDoctor ? values.roleDoctor : "",
                    "fonoMedico": values.cellphoneDoctor ? values.cellphoneDoctor : "",
                    "nombreInstitucion": values.nameInstitution ? values.nameInstitution : "",
                    "nombreDiretor": values.nameDirector ? values.nameDirector : "",
                    "ciudadInstitucion": values.cityInstitution ? values.cityInstitution : "",
                    "fonoInterrupcion": values.cellphoneNotification ? values.cellphoneNotification : "",
                    "emailInterrupcion": values.emailNotification ? values.emailNotification : "",
                    "equipos": newList,
                    "signedIn": getSignedIdStatus(),
                    // eslint-disable-next-line no-undef
                    "siteId": `${Liferay.ThemeDisplay.getScopeGroupId()}`,
                    "contentName": decode_utf8(props.web_content_return_fetch_electrodependent),
                    "empresa": props.codigo_empresa,
                    "url": props.url_ws_empresa
                },
                {
                    "certificado": values.fileCertificate,
                    "formulario": values.fileContactData,
                    "identidadPaciente": values.filePatientIdentity,
                    "identidRepresentante": values.filePatientRepresIdentity,
                    "boleta": values.ticketCopy,
                    "procuracion": values.fileCredentialRepres
                }
            ]
            console.log("JSON generado:", json);
            props.setJsonForm(json)
        }

    }

    function handleClickListEquip(obj) {
        if (obj.descEquipo && obj.potenciaNom && obj.horasConexion) {
            if (obj.horasConexion > 24) {
                setInputValidate({ ...inputValidate, ...inputValidate.validated.timeDailyConected = true, ...inputValidate.msg.timeDailyConected = "Horas de conexión no puede superar las 24 Hrs" })
            } else {
                setListEquipUsed([...listEquipUsed, obj])
                setValues({ ...values, typeEquipament: "", typeEquipamentName: "", ratedPower: "", timeDailyConected: "" })
                setInputValidate({ ...inputValidate, ...inputValidate.validated.timeDailyConected = false, ...inputValidate.msg.timeDailyConected = "" })
            }
        } else {
            if (!obj.descEquipo && !values.typeEquipament) {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.typeEquipament = true, ...inputValidate.msg.typeEquipament = "Debes seleccionar un tipo de equipamiento" })

            } else if (!obj.descEquipo && values.typeEquipamentName) {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.typeEquipamentName = true, ...inputValidate.msg.typeEquipamentName = "Debes ingresar la descripción del equipamiento" })
            }
            else if ((obj.descEquipo && values.typeEquipament) || (obj.descEquipo && values.typeEquipamentName)) {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.typeEquipament = false, ...inputValidate.msg.typeEquipament = "" })
            }

            if (!obj.potenciaNom) {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.ratedPower = true, ...inputValidate.msg.ratedPower = "Debes ingresar la potencia nominal del equipamiento" })
            } else {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.ratedPower = false, ...inputValidate.msg.ratedPower = "" })
            }
            if (!obj.horasConexion) {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.timeDailyConected = true, ...inputValidate.msg.timeDailyConected = "Debes ingresar las horas diarias de conexión del equipamiento" })
            } else {
                setInputValidate({ ...inputValidate, ...inputValidate.empty.timeDailyConected = false, ...inputValidate.msg.timeDailyConected = "" })
            }
            props.setGlobalAlert(`Complete todos los campos obligatorios.`, "warning");
        }
    }
    
    function funcValidateFieldSemicolon(e) {
        const regex = /^[\d,.]+$/;
        const valido = (regex.test(e.target.value));
        const nameInput = e.target.name 

        if(valido) {
            setInputValidate({...inputValidate, ...inputValidate.empty[nameInput] = false, ...inputValidate.msg[nameInput] = ""})
        } else {
            setInputValidate({...inputValidate, ...inputValidate.empty[nameInput] = true, ...inputValidate.msg[nameInput] = "Solo se permiten números, puntos y comas."})
        }
    }
    function deleteObjListEquip(obj) {
        const listEquipUsedCopy = [...listEquipUsed]
        listEquipUsedCopy.splice(listEquipUsedCopy?.indexOf(obj), 1)
        setListEquipUsed(listEquipUsedCopy)
    }

    React.useEffect(() => {
        if (props.detailClientJson) {
            setValues({
                ...values, comuna: props.detailClientJson?.COMUNA, calle: props.detailClientJson?.CALLE, number: props.detailClientJson?.NUMERO_CASA,
                dpto: `${props.detailClientJson?.SUPLEMENTO ? props.detailClientJson?.SUPLEMENTO : ""} ${props.detailClientJson?.PISO ? props.detailClientJson?.PISO : ""}`
            })
        }
    }, [props.detailClientJson])

    function verifDateMin() {
        if (values.fechaDesde < values.fechaHora) {
            return false
        } else {
            return true
        }
    }

    return (
        <div id="cge-formselectrodependent">
            <CGE.Panel>
                <CGE.PanelSection
                    title={"Se certifica como electrodependiente al paciente individualizado como:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, rutPatient: e.target.value })}
                                idFormElement="rutPatient"
                                mandatoryElement={true}
                                labelName="Rut:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutPatient || inputValidate?.validated?.rutPatient}
                                msgError={inputValidate?.msg?.rutPatient}
                                value={values.rutPatient}
                                typeElement="input-mask"
                                maxLength="12"
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, namePatient: e.target.value })}
                                idFormElement="namePatient"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Nombre:"
                                placeholder="Nombre Completo"
                                maxLength="100"
                                hasError={inputValidate?.empty?.namePatient}
                                msgError={inputValidate?.msg?.namePatient}
                                value={values.namePatient}
                            />
                        </div>

                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cellphonePatient: e.target.value })}
                                idFormElement="cellphonePatient"
                                mandatoryElement={true}
                                typeFormElement="text"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphonePatient || inputValidate?.validated?.cellphonePatient}
                                msgError={inputValidate?.msg?.cellphonePatient}
                                value={values.cellphonePatient}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, emailPatient: e.target.value })}
                                idFormElement="emailPatient"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailPatient || inputValidate?.validated?.emailPatient}
                                msgError={inputValidate?.msg?.emailPatient}
                                value={values.emailPatient}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, edadPatient: e.target.value })}
                                idFormElement="edadPatient"
                                labelName="Edad:"
                                placeholder="Edad"
                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                value={values.edadPatient}
                                typeFormElement="text"
                                typeElement="input-mask"
                                maxLength="2"
                                formatChars={{
                                    9: "[0-9]"
                                }}
                                mask="99"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, diagnosticPatient: e.target.value })}
                                idFormElement="diagnosticPatient"
                                typeElement="input"
                                maxLength="100"
                                labelName="Diagnóstico médico/Patología de Base 1:"
                                placeholder="Diagnóstico médico"
                                value={values.diagnosticPatient}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, descuento: e.target.value })}
                                idFormElement="descuento"
                                typeElement="input"
                                maxLength="100"
                                labelName="Descuento informado en Solicitud Electrodependiente:"
                                placeholder="Descuento informado"
                                value={values.descuento}
                            />
                        </div>
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Domicillio en donde reside el paciente:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, calleNDptoPatient: e.target.value })}
                                idFormElement="calleNDptoPatient"
                                typeElement="input"
                                labelName="Calle, N°, Dpto:"
                                placeholder="Calle, N°, Dpto"
                                hasError={inputValidate?.empty?.calleNDptoPatient}
                                msgError={inputValidate?.msg?.calleNDptoPatient}
                                value={values.calleNDptoPatient}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => {
                                    setValues({ ...values, regionPatient: e.target.value })
                                    props.setIdRegion(e.target.value)
                                }}
                                idFormElement="regionPatient"
                                mandatoryElement={true}
                                labelName="Región:"
                                typeElement="select"
                                hasError={inputValidate?.empty?.regionPatient}
                                msgError={inputValidate?.msg?.regionPatient}
                                value={values.regionPatient}
                                listOptions={props.optionsRegion}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, comunaPatient: e.target.value })}
                                idFormElement="comunaPatient"
                                mandatoryElement={true}
                                labelName="Comuna:"
                                listOptions={props.optionsComunaRegion}
                                typeElement="select"
                                value={values.comunaPatient}
                                hasError={inputValidate?.empty?.comunaPatient}
                                msgError={inputValidate?.msg?.comunaPatient}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Datos del representante legal o apoderado del paciente:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, rutTutor: e.target.value })}
                                idFormElement="rutTutor"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                labelName="Rut:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutTutor || inputValidate?.validated?.rutTutor}
                                msgError={inputValidate?.msg?.rutTutor}
                                value={values.rutTutor}
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                maxLength="12"
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, nameTutor: e.target.value })}
                                idFormElement="nameTutor"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Nombre:"
                                maxLength="100"
                                placeholder="Nombre Completo"
                                hasError={inputValidate?.empty?.nameTutor}
                                msgError={inputValidate?.msg?.nameTutor}
                                value={values.nameTutor}
                            />
                        </div>

                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cellphoneTutor: e.target.value })}
                                idFormElement="cellphoneTutor"
                                mandatoryElement={true}
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphoneTutor || inputValidate?.validated?.cellphoneTutor}
                                msgError={inputValidate?.msg?.cellphoneTutor}
                                value={values.cellphoneTutor}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, emailTutor: e.target.value })}
                                idFormElement="emailTutor"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Correo Electrónico:"
                                placeholder="Correo Electrónico"
                                hasError={inputValidate?.empty?.emailTutor || inputValidate?.validated?.emailTutor}
                                msgError={inputValidate?.msg?.emailTutor}
                                value={values.emailTutor}
                            />
                        </div>
                    </div>

                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Periodo indicado de Electro-Dependencia:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaDesde: e.target.value })}
                                idFormElement="fechaDesde"
                                mandatoryElement={true}
                                typeElement="input"
                                typeFormElement="date"
                                labelName="Fecha Desde:"
                                placeholder="Fecha Desde"
                                hasError={inputValidate?.empty?.fechaDesde || inputValidate?.validated?.fechaDesde}
                                msgError={inputValidate?.msg?.fechaDesde}
                                value={values.fechaDesde}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, fechaHora: e.target.value })}
                                idFormElement="fechaHora"
                                mandatoryElement={true}
                                min={values.fechaDesde && values.fechaDesde}
                                typeElement="input"
                                typeFormElement="date"
                                labelName="Fecha Hasta:"
                                placeholder="Fecha Hasta"
                                hasError={inputValidate?.empty?.fechaHora || inputValidate?.validated?.fechaHora}
                                msgError={inputValidate?.msg?.fechaHora}
                                value={values.fechaHora}
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Ingresa en esta sección cada uno de los equipos médicos a los que se conecta el paciente:"}>
                    <div className="row">
                        <div className="col-md-5">
                            <CGE.FormsField
                                handleChange={(e) => setValues({
                                    ...values,
                                    typeEquipament: e.target.value,
                                    typeEquipamentName: e.target.value !== "6" && e.target.value !== "" ? document.getElementById('typeEquipament')?.options
                                    [document.getElementById('typeEquipament')?.options.selectedIndex]?.label : ""
                                })}
                                idFormElement="typeEquipament"
                                mandatoryElement={true}
                                labelName="Tipo - Descripción de equipamiento:"
                                listOptions={props.optionsTypeEquipments}
                                typeElement="select"
                                value={values.typeEquipament}
                                hasError={inputValidate?.empty?.typeEquipament}
                                msgError={inputValidate?.msg?.typeEquipament}
                            />
                            {values.typeEquipament === '6' &&
                                <div className="">
                                    <CGE.FormsField
                                        handleChange={(e) => setValues({
                                            ...values,
                                            typeEquipamentName: e.target.value
                                        })}
                                        idFormElement="typeEquipamentName"
                                        mandatoryElement={true}
                                        typeElement="input"
                                        maxLength="100"
                                        placeholder="Descripción de equipamiento"
                                        hasError={inputValidate?.empty?.typeEquipamentName}
                                        msgError={inputValidate?.msg?.typeEquipamentName}
                                        value={values.typeEquipamentName}
                                    />
                                </div>
                            }
                        </div>

                        <div className="col-md-4">
                            <CGE.FormsField
                                handleChange={(e) => {
                                    setValues({ ...values, ratedPower: e.target.value });
                                    funcValidateFieldSemicolon(e);
                                }}    
                                idFormElement="ratedPower"
                                mandatoryElement={true}
                                labelName="Potencia Nominal (en Watts):"
                                placeholder="Potencia Nominal en Watts (Ej: 200)"
                                hasError={inputValidate?.empty?.ratedPower}
                                msgError={inputValidate?.msg?.ratedPower}
                                value={values.ratedPower}
                                typeFormElement="text"
                                typeElement="input-mask"
                                maxLength="12"
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => {
                                    setValues({ ...values, timeDailyConected: e.target.value });
                                    funcValidateFieldSemicolon(e);
                                }}
                                idFormElement="timeDailyConected"
                                mandatoryElement={true}
                                labelName="Horas diarias de conexíon:"
                                placeholder="Horas diarias (Ej: 2)"
                                hasError={inputValidate?.empty?.timeDailyConected || inputValidate?.validated?.timeDailyConected}
                                msgError={inputValidate?.msg?.timeDailyConected}
                                value={values.timeDailyConected}
                                typeFormElement="text"
                                typeElement="input-mask"
                                maxLength="12"
                            />
                        </div>
                        <div className='col-md-12 pt-2 d-flex justify-content-end'>

                            <div className="">
                                <CGE.Button
                                    size="sm"
                                    label="Agregar"
                                    onClick={() => handleClickListEquip({
                                        descEquipo: values.typeEquipamentName,
                                        potenciaNom: values.ratedPower,
                                        horasConexion: values.timeDailyConected,
                                        eliminar: ""
                                    })}
                                />
                                <CGE.Spacing type="md" />

                            </div>

                        </div>
                    </div>
                    {listEquipUsed.length > 0 &&
                        <ListEquipments
                            props={{ ...props, listEquipUsed, deleteObjListEquip }}
                            showDeleteColumn={true}
                        />
                    }
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Médico que certifica:"}>
                    <div className="row">
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, rutDoctor: e.target.value })}
                                idFormElement="rutDoctor"
                                mandatoryElement={true}
                                typeElement="input-mask"
                                labelName="Rut:"
                                placeholder="Rut(Ej: 12345678-9)"
                                hasError={inputValidate?.empty?.rutDoctor || inputValidate?.validated?.rutDoctor}
                                msgError={inputValidate?.msg?.rutDoctor}
                                value={values.rutDoctor}
                                beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                maxLength="12"
                                formatChars={{
                                    9: "[0-9]",
                                    k: "[Kk0-9]",
                                }}
                                mask="9.999.999-kk"
                                maskChar={null}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, nameDoctor: e.target.value })}
                                idFormElement="nameDoctor"
                                typeElement="input"
                                maxLength="100"
                                labelName="Nombre:"
                                placeholder="Nombre Completo"

                                value={values.nameDoctor}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, roleDoctor: e.target.value })}
                                idFormElement="roleDoctor"
                                typeElement="input"
                                labelName="Cargo"
                                maxLength="100"
                                placeholder="Cargo"
                                value={values.roleDoctor}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cellphoneDoctor: e.target.value })}
                                idFormElement="cellphoneDoctor"
                                minLength="9"
                                maxLength="9"
                                typeElement="input-mask"
                                formatChars={{
                                    9: "[0-9]",
                                }}
                                mask="999999999"
                                maskChar={null}
                                labelName="Teléfono de contacto:"
                                placeholder="Fono(Ej: 995048949)"
                                hasError={inputValidate?.empty?.cellphoneDoctor || inputValidate?.validated?.cellphoneDoctor}
                                msgError={inputValidate?.msg?.cellphoneDoctor}
                                value={values.cellphoneDoctor}
                            />
                        </div>

                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title={"Establecimento del Salud:"}>
                    <div className="row">
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, nameInstitution: e.target.value })}
                                idFormElement="nameInstitution"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Nombre Institución: "
                                placeholder="Nombre Institución"
                                hasError={inputValidate?.empty?.nameInstitution}
                                msgError={inputValidate?.msg?.nameInstitution}
                                value={values.nameInstitution}
                            />
                        </div>
                        <div className="col-md-6">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, nameDirector: e.target.value })}
                                idFormElement="nameDirector"
                                mandatoryElement={true}
                                typeElement="input"
                                maxLength="100"
                                labelName="Nombre Completo:"
                                placeholder="Nombre del Director"
                                hasError={inputValidate?.empty?.nameDirector}
                                msgError={inputValidate?.msg?.nameDirector}
                                value={values.nameDirector}
                            />
                        </div>
                        <div className="col-md-3">
                            <CGE.FormsField
                                handleChange={(e) => setValues({ ...values, cityInstitution: e.target.value })}
                                idFormElement="cityInstitution"
                                mandatoryElement={true}
                                typeElement="input"
                                labelName="Ciudad:"
                                maxLength="100"
                                placeholder="Ciudad"
                                hasError={inputValidate?.empty?.cityInstitution}
                                msgError={inputValidate?.msg?.cityInstitution}
                                value={values.cityInstitution}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.Heading
                                className="color-blue font-weight-bold mb-4"
                                size="4"
                                text={decode_utf8(props.description_forms_eleccion_medio_informarse)}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxEmail}
                                labelName="Enviar certificado por correo electrónico"
                                handleChange={() => setValueCheckBoxEmail((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={false}
                                typeElement="input"
                            />
                            {valueCheckBoxEmail &&
                                <div style={{ position: "relative", top: "-40px" }}>
                                    <CGE.FormsField
                                        handleChange={(e) => setValues({ ...values, emailNotification: e.target.value })}
                                        idFormElement="emailNotification"
                                        mandatoryElement={valueCheckBoxEmail}
                                        labelName="Correo Electrónico:"
                                        maxLength="100"
                                        typeElement="input"
                                        disabled={!valueCheckBoxEmail}
                                        placeholder="Ingresar el correo electrónico"
                                        hasError={inputValidate?.empty?.emailNotification || inputValidate?.validated?.emailNotification}
                                        msgError={inputValidate?.msg?.emailNotification}
                                    />
                                </div>

                            }
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxCell}
                                labelName="Enviar información por Llamada al Celular"
                                handleChange={() => setValueCheckBoxEmCell((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={false}
                                typeElement="input"
                            />
                            {valueCheckBoxCell &&
                                <div style={{ position: "relative", top: "-40px" }}>
                                    <CGE.FormsField
                                        handleChange={(e) => setValues({ ...values, cellphoneNotification: e.target.value })}
                                        idFormElement="cellphoneNotification"
                                        mandatoryElement={valueCheckBoxCell}
                                        labelName="Llamada al Celular:"
                                        minLength="9"
                                        maxLength="9"
                                        typeElement="input-mask"
                                        formatChars={{
                                            9: "[0-9]",
                                        }}
                                        mask="999999999"
                                        maskChar={null}
                                        disabled={!valueCheckBoxCell}
                                        placeholder="Fono(Ej: 995048949)"
                                        hasError={inputValidate?.empty?.cellphoneNotification || inputValidate?.validated?.cellphoneNotification}
                                        msgError={inputValidate?.msg?.cellphoneNotification}
                                    />
                                </div>
                            }
                        </div>
                        <div className="col-md-12">
                            <CGE.Heading
                                className="color-blue font-weight-bold mb-2"
                                size="4"
                                text={decode_utf8(props.description_forms_tipos_documentacion)}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileCertificate"
                                labelInput="Certificado médico que acredita condición de electrodependencia:"
                                deleteFile={() => setValues({ ...values, 'fileCertificate': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileCertificate': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileCertificate || inputValidate?.validated?.fileCertificate}
                                msgError={inputValidate?.msg?.fileCertificate}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="filePatientIdentity"
                                labelInput="Cédula de Identidad del paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'filePatientIdentity': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'filePatientIdentity': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.filePatientIdentity || inputValidate?.validated?.filePatientIdentity}
                                msgError={inputValidate?.msg?.filePatientIdentity}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileContactData"
                                labelInput="Formulario con los datos de contacto con el paciente y su representante (o apoderado):"
                                deleteFile={() => setValues({ ...values, 'fileContactData': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileContactData': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileContactData || inputValidate?.validated?.fileContactData}
                                msgError={inputValidate?.msg?.fileContactData}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="filePatientRepresIdentity"
                                labelInput="Cédula de Identidad del representante (o apoderado) (*) del paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'filePatientRepresIdentity': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'filePatientRepresIdentity': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.filePatientRepresIdentity || inputValidate?.validated?.filePatientRepresIdentity}
                                msgError={inputValidate?.msg?.filePatientRepresIdentity}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileUploaded
                                idInput="ticketCopy"
                                labelInput="Copia de la boleta donde se inscribe al paciente electrodependiente:"
                                deleteFile={() => setValues({ ...values, 'ticketCopy': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'ticketCopy': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.ticketCopy || inputValidate?.validated?.ticketCopy}
                                msgError={inputValidate?.msg?.ticketCopy}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>

                        <div className="col-md-6">
                            <FileUploaded
                                idInput="fileCredentialRepres"
                                labelInput="Documento que acredita al representante (o apoderado) (*) del paciente:"
                                deleteFile={() => setValues({ ...values, 'fileCredentialRepres': '' })}
                                onFileSelectSuccess={(file) => setValues({ ...values, 'fileCredentialRepres': file })}
                                setErroUploadFile={setErroUploadFile}
                                dataProps={props}
                                mandatoryElement={true}
                                maxFileSize={props.tamano_maximo_de_archivo_MB}
                                typeFile={props.tipo_de_archivo}
                                hasError={inputValidate?.empty?.fileCredentialRepres || inputValidate?.validated?.fileCredentialRepres}
                                msgError={inputValidate?.msg?.fileCredentialRepres}
                                msgErrorFileSize={`El tamaño del archivo debe ser inferior a ${props.tamano_maximo_de_archivo_MB}MB`}
                                multiFiles={false}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.Text
                                className="color-blue font-weight-bold mb-2"
                                size="2"
                                text="(*): Si el paciente es su propio representante legal y no posee apoderado, ingresar la cédula de
                                 identidad de paciente en reemplazo de la cédula de identidad del representante (o apoderado) y como 
                                 documento que lo acredita como tal."
                            />
                        </div>
                    </div>
                </CGE.PanelSection>
                <CGE.PanelSection
                    title="9. Términos y condiciones">
                    <div className="row">
                        <div className="col-md-12">
                            <WebContentTermsElectrod
                                props={props}
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FormsField
                                checked={valueCheckBoxTerms}
                                labelName="Acepto los términos y condiciones"
                                handleChange={() => setValueCheckBoxTerms((val) => !val)}
                                idFormElement="numberClientId"
                                typeFormElement="checkbox"
                                mandatoryElement={true}
                                typeElement="input"
                            />
                        </div>
                        <div className="col-md-12">
                            <CGE.FieldRecaptcha
                                onChange={onChangeReCaptcha}
                                sitekey={props.api_key_recaptcha}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <CGE.Button
                            label="Enviar"
                            onClick={() => handleSubmit()}
                        />
                    </div>
                </CGE.PanelSection>
            </CGE.Panel>
        </div>
    )
}

export default FormsElectrodependent